module.exports = __webpack_public_path__ + "img/help_sheet_default.83eb0dd6.svg";